/* Omni Studio website prototype: shared behaviour.
   No libraries. Everything here is progressive enhancement: with JavaScript off, or with reduced motion, every page shows its
   final state and all content is readable. Motion rules: transform and opacity only, calm, pausable, no scroll hijacking. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  /* Shopify: asset URLs are fingerprinted CDN URLs. Runtime-built asset paths resolve through window.OW_ASSETS (snippets/ow-asset-map.liquid). */
  function OW_ASSET(p) { var m = window.OW_ASSETS; return (m && m[p]) || p; }
  var reduce = false;
  try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var hasIO = 'IntersectionObserver' in window;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* ---------- calm on load ----------
     Nothing moves until the visitor scrolls, clicks, touches or presses a key (the hero gets one short fade in CSS).
     Demos, typing, pulses and counters call whenActed(fn) and start then, and only while on screen. */
  var acted = false, actedQ = [];
  function whenActed(fn) { if (acted) fn(); else actedQ.push(fn); }
  function actNow() {
    if (acted) return; acted = true; root.classList.add('ow-acted');
    var q = actedQ; actedQ = []; q.forEach(function (f) { try { f(); } catch (e) {} });
  }
  window.OW_whenActed = whenActed;
  /* reduced motion: nothing animates anyway, so render demos in their still state right away */
  if (reduce) { acted = true; root.classList.add('ow-acted'); }
  if (!reduce) {
    ['scroll', 'wheel', 'touchmove', 'keydown'].forEach(function (ev) { addEventListener(ev, actNow, { passive: true, once: true }); });
    addEventListener('pointerdown', function (e) { if (!e.target.closest || !e.target.closest('[data-pl-toggle]')) actNow(); }, { passive: true, once: true });
  }

  /* ---------- theme (kit tokens do the work; remembered per viewer when storage is allowed) ---------- */
  var THEME_KEY = 'omni-site-theme';
  function systemDark() { try { return matchMedia('(prefers-color-scheme: dark)').matches; } catch (e) { return false; } }
  function currentDark() { var t = root.getAttribute('data-os-theme'); return t ? t === 'dark' : systemDark(); }
  try { var saved = localStorage.getItem(THEME_KEY); if (saved === 'dark' || saved === 'light') root.setAttribute('data-os-theme', saved); } catch (e) {}
  $$('[data-theme-toggle]').forEach(function (b) {
    var sync = function () { b.setAttribute('aria-pressed', String(currentDark())); };
    sync();
    b.addEventListener('click', function () {
      var next = currentDark() ? 'light' : 'dark';
      root.setAttribute('data-os-theme', next);
      try { localStorage.setItem(THEME_KEY, next); } catch (e) {}
      $$('[data-theme-toggle]').forEach(function (x) { x.setAttribute('aria-pressed', String(next === 'dark')); });
    });
  });

  /* ---------- mobile menu ---------- */
  var mb = $('[data-menu-btn]'), mn = $('[data-mnav]');
  if (mb && mn) {
    var head = mb.closest('header') || $('.w-head');
    // Fit the open panel between the header's bottom edge and the bottom of the screen. The panel sits inside the sticky
    // header, whose backdrop-filter makes the header (not the screen) the panel's containing block, and the header moves
    // with the prototype strip, so the CSS offset alone leaves a gap and a panel only a few pixels tall.
    var placeMenu = function () {
      if (mn.hidden || !head) return;
      mn.style.top = '0px'; mn.style.bottom = 'auto';
      var cb = mn.getBoundingClientRect().top, hb = Math.max(0, head.getBoundingClientRect().bottom);
      mn.style.top = Math.round(hb - cb) + 'px';
      mn.style.height = Math.max(0, Math.round(innerHeight - hb)) + 'px';
    };
    var setMenu = function (open) {
      mn.hidden = !open; mb.setAttribute('aria-expanded', String(open)); mb.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); doc.body.style.overflow = open ? 'hidden' : '';
      if (open) placeMenu(); else { mn.style.top = mn.style.bottom = mn.style.height = ''; }
    };
    window.addEventListener('resize', placeMenu);
    mb.addEventListener('click', function () { setMenu(mn.hidden); });
    mn.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !mn.hidden) { setMenu(false); mb.focus(); } });
    try { matchMedia('(min-width: 981px)').addEventListener('change', function (m) { if (m.matches) setMenu(false); }); } catch (e) {}
  }

  /* ---------- scroll reveal ---------- */
  root.classList.add('js');
  if (!reduce && hasIO) {
    root.classList.add('js-anim');
    var rio = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal], .fx-matrix').forEach(function (el) {
      /* already on screen at load: show it in place, no movement */
      if (el.getBoundingClientRect().top < innerHeight) { el.setAttribute('data-instant', ''); el.classList.add('is-in'); } else rio.observe(el);
    });
    window.__revealAll = function () { $$('[data-reveal], .fx-matrix').forEach(function (el) { el.classList.add('is-in'); }); };
  } else {
    window.__revealAll = function () {};
  }

  /* ---------- step player ----------
     Markup contract (see BUILD-GUIDE.md):
       <div class="pl" data-player data-loop="true" data-autoplay="true">
         <ol class="pl__rail"><li><button class="pl__tab" data-step="0" style="--ms:4200ms">...<span class="pl__prog"><i></i></span></button></li>...</ol>
         ... any element with data-step="i"  -> gets is-active / is-done / is-todo
         ... any element with data-from="n"  -> gets is-on when active >= n
         ... any element with data-at="n"    -> gets is-on when active == n
         ... .pl__slide[data-step]           -> only the active slide shows (while live)
         <button data-pl-toggle>Pause</button>
       </div>
     The root receives data-active="i" and --active:i, so CSS can animate any diagram from the current step.
     Time is owned by CSS: each active tab's progress bar animates for --ms, and animationend advances the player. */
  function Player(el) {
    var tabs = $$('.pl__tab', el);
    var n = 0;
    $$('[data-step]', el).forEach(function (x) { n = Math.max(n, +x.getAttribute('data-step') + 1); });
    var loop = el.getAttribute('data-loop') !== 'false';
    var auto = el.getAttribute('data-autoplay') !== 'false' && !reduce && tabs.length > 0;
    var active = 0, userPaused = false, visible = true, started = false;
    var toggle = $('[data-pl-toggle]', el), rewind = $('[data-pl-rewind]', el);
    var typers = $$('[data-type]', el);
    var typeToken = 0;
    var phoneMq = null; try { phoneMq = matchMedia('(max-width: 640px)'); } catch (e) {}
    /* only the active slide is exposed to screen readers, except on a phone: there the slides of a swipe row are all shown, so none is hidden */
    function slideAria(x) { x.setAttribute('aria-hidden', (+x.getAttribute('data-step') === active || (phoneMq && phoneMq.matches && x.closest('[data-swipe]'))) ? 'false' : 'true'); }

    el.classList.add('is-live');
    if (!auto) el.classList.add('no-auto');

    function setPaused() { el.classList.toggle('is-paused', userPaused || !visible || !acted); }
    function typeNow(node, text, token) {
      node.textContent = '';
      node.classList.add('w-caret');
      var i = 0;
      (function tick() {
        if (token !== typeToken) return;
        i++; node.textContent = text.slice(0, i);
        if (i < text.length) setTimeout(tick, el.classList.contains('jd') ? 12 : 16); else node.classList.remove('w-caret');
      })();
    }
    /* Job demo on a phone: the conversation and the approval card are always shown (phone rule in ow-site.css:
       .jd.is-live .rv[data-from="0|1|2"] and .rv[data-at="2"]), so they must not be inert, or a visible Approve button does nothing.
       Once a decision is made (data-outcome) the approval actions go back to their normal state. */
    function phoneCard() { return !!(phoneMq && phoneMq.matches && el.classList.contains('jd') && el.id !== 'jobdemo'); }
    function setInert(x, on) {
      if (!x.classList.contains('rv')) return;
      var from = x.getAttribute('data-from'), at = x.getAttribute('data-at');
      var shown = phoneCard() && (from !== null ? +from <= 2 : (at === '2' && !el.hasAttribute('data-outcome')));
      if (on || shown) x.removeAttribute('inert'); else x.setAttribute('inert', '');
    }
    function syncInert() {
      $$('[data-from]', el).forEach(function (x) { setInert(x, active >= +x.getAttribute('data-from')); });
      $$('[data-at]', el).forEach(function (x) { setInert(x, active === +x.getAttribute('data-at')); });
    }
    function render() {
      el.setAttribute('data-active', String(active));
      el.style.setProperty('--active', String(active));
      $$('[data-step]', el).forEach(function (x) {
        var i = +x.getAttribute('data-step');
        x.classList.toggle('is-active', i === active);
        x.classList.toggle('is-done', i < active);
        x.classList.toggle('is-todo', i > active);
        if (x.classList.contains('pl__tab')) { if (i === active) x.setAttribute('aria-current', 'step'); else x.removeAttribute('aria-current'); }
        if (x.classList.contains('pl__slide')) slideAria(x);
      });
      $$('[data-from]', el).forEach(function (x) { x.classList.toggle('is-on', active >= +x.getAttribute('data-from')); });
      $$('[data-at]', el).forEach(function (x) { x.classList.toggle('is-on', active === +x.getAttribute('data-at')); });
      typeToken++;
      typers.forEach(function (t) {
        var at = t.getAttribute('data-type-at');
        var full = t.getAttribute('data-type');
        if (at !== null && +at === active && !reduce) typeNow(t, full, typeToken);
        else if (at !== null && +at > active) t.textContent = '';
        else t.textContent = full;
      });
      el.dispatchEvent(new CustomEvent('pl:step', { detail: { index: active }, bubbles: true }));
      syncInert();
    }
    function restartBar() {
      // restart the CSS animation of the active progress bar
      el.classList.remove('is-playing'); void el.offsetWidth; if (auto) el.classList.add('is-playing');
    }
    function go(i) {
      active = (i + n) % n;
      render(); restartBar(); updateToggle();
    }
    function updateToggle() {
      if (!toggle) return;
      var span = $('span', toggle), use = $('use', toggle);
      var held = userPaused;
      toggle.setAttribute('aria-pressed', String(held));
      if (span) span.textContent = held ? (toggle.getAttribute('data-label-play') || 'Play animation') : (toggle.getAttribute('data-label-pause') || 'Pause animation');
      if (use) use.setAttribute('href', held ? '#i-play' : '#i-pause');
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { actNow(); go(+t.getAttribute('data-step')); el.dispatchEvent(new CustomEvent('pl:user', { bubbles: true })); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(active + 1); tabs[active].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(active - 1); tabs[active].focus(); }
        if (e.key === 'Home') { e.preventDefault(); go(0); tabs[0].focus(); }
        if (e.key === 'End') { e.preventDefault(); go(n - 1); tabs[n - 1].focus(); }
      });
    });
    if (toggle) toggle.addEventListener('click', function () { actNow(); userPaused = !userPaused; setPaused(); updateToggle(); el.dispatchEvent(new CustomEvent('pl:user', { bubbles: true })); });
    if (rewind) rewind.addEventListener('click', function () { actNow(); userPaused = false; setPaused(); go(0); el.dispatchEvent(new CustomEvent('pl:rewind', { bubbles: true })); el.dispatchEvent(new CustomEvent('pl:user', { bubbles: true })); });
    el.addEventListener('click', function (e) { var g = e.target.closest('[data-pl-go]'); if (g && el.contains(g)) { actNow(); go(+g.getAttribute('data-pl-go')); el.dispatchEvent(new CustomEvent('pl:user', { bubbles: true })); } });
    el.addEventListener('animationend', function (e) {
      if (e.animationName !== 'pl-fill') return;
      if (!tabs.length || e.target.closest('.pl__tab') !== tabs[active]) return;
      if (active < n - 1) go(active + 1);
      else if (loop) go(0);
      else { el.classList.remove('is-playing'); }
    });
    function begin() {
      if (started || !visible) return;
      started = true;
      if (el.hasAttribute('data-first-run') && !reduce && !phoneCard()) active = +el.getAttribute('data-first-run');
      render(); restartBar();
    }
    if (hasIO) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting; setPaused();
        if (visible && !started) whenActed(begin);
      }, { threshold: 0.25 }).observe(el);
      whenActed(function () { setPaused(); updateToggle(); begin(); });
    } else { started = true; }
    // initial state: first step (autoplay waits until visible); without autoplay start from the requested step
    var start = el.hasAttribute('data-start') ? +el.getAttribute('data-start') : (reduce ? n - 1 : 0);
    active = start; render(); if (auto) { el.classList.add('is-playing'); } updateToggle(); setPaused();
    try { if (phoneMq) phoneMq.addEventListener('change', function () { $$('.pl__slide[data-step]', el).forEach(slideAria); syncInert(); }); } catch (e) {}
    el.__player = {
      go: go,
      get active() { return active; },
      pause: function () { userPaused = true; setPaused(); updateToggle(); },
      resume: function () { userPaused = false; setPaused(); updateToggle(); },
      restart: function () { userPaused = false; setPaused(); go(0); }
    };
  }
  $$('[data-player]').forEach(Player);

  /* ---------- hub pulses (connected record) ---------- */
  $$('[data-hub]').forEach(function (hub) {
    var sats = $$('.fx-hub__sat', hub), pulses = $$('.fx-hub__pulse', hub), vis = false, i = 0;
    if (reduce || !hasIO) return;
    new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }, { threshold: 0.3 }).observe(hub);
    setInterval(function () {
      if (!vis || !acted) return;
      var s = sats[i % sats.length], p = pulses[i % pulses.length];
      sats.forEach(function (x) { x.classList.remove('is-active'); });
      pulses.forEach(function (x) { x.classList.remove('is-on'); });
      if (p) { void p.getBoundingClientRect(); p.classList.add('is-on'); }
      setTimeout(function () { if (s) s.classList.add('is-active'); }, 900);
      i++;
    }, 2400);
  });

  /* ---------- stage story (scroll-linked, no scroll hijacking) ---------- */
  $$('[data-stagestory]').forEach(function (box) {
    var panels = $$('.w-pn', box), stages = $$('.os-stage', box);
    function mark(n) {
      panels.forEach(function (p, i) { p.classList.toggle('is-on', i === n); });
      stages.forEach(function (s, i) {
        s.classList.remove('is-done', 'is-current'); s.removeAttribute('aria-current');
        var label = s.getAttribute('data-label') || s.textContent.replace(/^\s*\d+\s*/, '').trim();
        s.setAttribute('data-label', label);
        if (i < n) { s.classList.add('is-done'); s.innerHTML = '<svg class="os-icon os-icon--14" aria-hidden="true"><use href="#i-check"/></svg>' + label; }
        else { s.innerHTML = '<span class="os-stage__n">' + (i + 1) + '</span>' + label; if (i === n) { s.classList.add('is-current'); s.setAttribute('aria-current', 'step'); } }
      });
    }
    mark(0);
    if (hasIO) {
      var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) mark(panels.indexOf(e.target)); }); }, { rootMargin: '-42% 0px -42% 0px' });
      panels.forEach(function (p) { sio.observe(p); });
    }
    stages.forEach(function (s, i) {
      s.style.cursor = 'pointer'; s.setAttribute('tabindex', '0'); s.setAttribute('role', 'button');
      var go = function () { panels[i].scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); };
      s.addEventListener('click', go);
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
  });

  /* ---------- command palette demo ---------- */
  var cmd = $('[data-cmd]');
  if (cmd && !reduce && hasIO) {
    var q = $('[data-cmd-q]', cmd), prev = $('[data-cmd-prev]'), box = $('.w-cmd', cmd), TXT = q.getAttribute('data-cmd-q'), cv = false;
    new IntersectionObserver(function (es) { cv = es[0].isIntersecting; }, { threshold: 0.4 }).observe(cmd);
    (async function cl() {
      while (true) {
        q.textContent = ''; q.classList.add('w-caret'); prev.classList.remove('is-on'); box.classList.add('is-typing');
        while (!cv || !acted) await wait(250);
        await wait(500);
        for (var i = 1; i <= TXT.length; i++) { q.textContent = TXT.slice(0, i); if (i === 2) box.classList.remove('is-typing'); await wait(90); }
        await wait(900); prev.classList.add('is-on'); await wait(6500);
      }
    })();
  }

  /* ---------- approval demo ---------- */
  $$('[data-apv]').forEach(function (a) {
    var draft = $('.apv__draft', a), edited = false;
    function logIt(text) { var li = $('.apv__log [data-log="' + text + '"]', a); if (li) li.classList.add('is-on'); }
    a.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var act = b.getAttribute('data-act');
      if (act === 'edit') {
        var on = draft.getAttribute('contenteditable') === 'true';
        draft.setAttribute('contenteditable', on ? 'false' : 'true'); b.textContent = on ? 'Edit' : 'Done editing';
        if (!on) { draft.focus(); edited = true; }
      } else if (act === 'approve') {
        draft.setAttribute('contenteditable', 'false'); a.setAttribute('data-state', 'approved'); logIt(edited ? 'edited' : 'approved'); logIt('sent');
      } else if (act === 'reject') {
        draft.setAttribute('contenteditable', 'false'); a.setAttribute('data-state', 'rejected'); logIt('rejected');
      } else if (act === 'again') {
        a.removeAttribute('data-state'); edited = false; $$('.apv__log li', a).forEach(function (li) { if (li.getAttribute('data-log') !== 'drafted') li.classList.remove('is-on'); });
        var eb = $('[data-act="edit"]', a); if (eb) eb.textContent = 'Edit';
      }
    });
  });

  /* ---------- AI desks panel (kit os-ai-panel) ---------- */
  var desksBox = $('[data-desks]');
  if (desksBox && !reduce && hasIO) {
    var desks = $$('.os-ai-desk', desksBox), feed = $$('[data-feed] li', desksBox), dv = false, di = 0;
    var says = ['', 'Reading the offer', 'Pulling comparable sales', 'Checking the lease terms', 'Checking open repairs'];
    new IntersectionObserver(function (es) { dv = es[0].isIntersecting; }, { threshold: 0.3 }).observe(desksBox);
    setInterval(function () {
      if (!dv || !acted) return;
      di = (di + 1) % desks.length;
      desks.forEach(function (d, i) {
        d.classList.toggle('is-active', i === di || i === 0);
        var s = $('span', d); if (!s) return;
        s.textContent = i === 0 ? 'Coordinating' : (i === di ? (says[di] || 'Working') : 'Standby');
      });
      feed.forEach(function (li, i) { li.style.opacity = i <= (di % feed.length) ? '1' : '.45'; });
    }, 2200);
  }

  /* ---------- industries dropdown (desktop header) ---------- */
  $$('[data-dd]').forEach(function (dd) {
    var btn = $('.w-dd__btn', dd), panel = $('.w-dd__panel', dd), t = null;
    function open(v) { clearTimeout(t); panel.hidden = !v; btn.setAttribute('aria-expanded', String(v)); }
    /* a pointer that hovers the trigger has already opened the menu: the click keeps it open (it used to close it again); the next click toggles as before */
    var opened = false;
    btn.addEventListener('click', function () { if (opened) { opened = false; open(true); } else open(panel.hidden); });
    dd.addEventListener('mouseenter', function () { if (matchMedia('(hover: hover)').matches) { opened = true; open(true); } });
    dd.addEventListener('mouseleave', function () { opened = false; t = setTimeout(function () { open(false); }, 160); });
    dd.addEventListener('focusout', function (e) { if (!dd.contains(e.relatedTarget)) open(false); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { open(false); btn.focus(); } });
    doc.addEventListener('click', function (e) { if (!dd.contains(e.target)) open(false); });
    /* the menu icons are lazy images in a hidden panel: fetch them at low priority once the page is idle (or on first hover or focus), so the first open shows no empty squares */
    var warmed = false;
    function warm() { if (warmed) return; warmed = true; $$('img.ow-ico[loading="lazy"]', panel).forEach(function (i) { i.fetchPriority = 'low'; i.loading = 'eager'; }); }
    dd.addEventListener('mouseenter', warm); btn.addEventListener('focus', warm); btn.addEventListener('touchstart', warm, { passive: true });
    if (dd.offsetParent !== null && matchMedia('(hover: hover)').matches) { if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500); }
  });

  /* ---------- inline tooltips (Twilio first mention) & FAQ hash auto-open ---------- */
  $$('[data-tip-toggle]').forEach(function (btn) {
    var wrap = btn.closest('.os-tip-wrap');
    if (!wrap) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });
  doc.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.os-tip-wrap')) {
      $$('.os-tip-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
        var b = $('[data-tip-toggle]', w); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $$('.os-tip-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open');
        var b = $('[data-tip-toggle]', w); if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });
  $$('.w-faq details').forEach(function (d) {
    var s = $('summary', d);
    if (s && !d.id && /twilio|calls and texts/i.test(s.textContent)) d.id = 'faq-twilio';
  });
  function openHashFaq() {
    var h = (location.hash || '').slice(1);
    if (!h) return;
    var target = doc.getElementById(h);
    if (target && target.tagName === 'DETAILS') {
      target.open = true;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
  }
  openHashFaq();
  window.addEventListener('hashchange', openHashFaq);

  /* ---------- tabs (accessible, used by the workspace selector and similar) ---------- */
  $$('[data-tabs]').forEach(function (box) {
    var btns = $$('[role="tab"]', box), panels = $$('[role="tabpanel"]', box);
    function sel(i, focus) {
      btns.forEach(function (b, j) { b.setAttribute('aria-selected', String(i === j)); b.tabIndex = i === j ? 0 : -1; if (i === j && focus) b.focus(); });
      panels.forEach(function (p, j) { p.hidden = i !== j; });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { sel(i); });
      b.addEventListener('keydown', function (e) {
        var k = e.key, n = btns.length;
        if (k === 'ArrowRight' || k === 'ArrowDown') { e.preventDefault(); sel((i + 1) % n, true); }
        else if (k === 'ArrowLeft' || k === 'ArrowUp') { e.preventDefault(); sel((i - 1 + n) % n, true); }
        else if (k === 'Home') { e.preventDefault(); sel(0, true); }
        else if (k === 'End') { e.preventDefault(); sel(n - 1, true); }
      });
    });
    var init = btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; });
    sel(init < 0 ? 0 : init);
    var hash = (location.hash || '').slice(1);
    if (hash) { var hi = btns.findIndex(function (b) { return b.getAttribute('data-hash') === hash; }); if (hi >= 0) sel(hi); }
  });

  /* ---------- filters (data-filter buttons toggle [data-cat] items) ---------- */
  $$('[data-filter-group]').forEach(function (g) {
    var btns = $$('[data-filter]', g), items = $$(g.getAttribute('data-filter-group'));
    var count = $('[data-filter-count]', doc);
    function apply(cat) {
      var shown = 0;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === cat)); });
      items.forEach(function (it) { var ok = cat === 'all' || it.getAttribute('data-cat') === cat; it.hidden = !ok; if (ok) shown++; });
      if (count) count.textContent = shown + (shown === 1 ? ' role' : ' roles');
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { apply(b.getAttribute('data-filter')); }); });
    apply('all');
  });

  /* ---------- count-up numbers (data-count="4999" data-prefix="$") ---------- */
  $$('[data-count]').forEach(function (el) {
    var target = parseFloat(el.getAttribute('data-count')), dec = +(el.getAttribute('data-dec') || 0), pre = el.getAttribute('data-prefix') || '';
    var fmt = function (v) { return pre + v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }); };
    el.textContent = fmt(target);
    if (reduce || !hasIO) return;
    var done = false;
    new IntersectionObserver(function (es, o) {
      if (!es[0].isIntersecting || done) return; done = true; o.disconnect();
      whenActed(function () {
        var t0 = performance.now(), dur = 700;
        (function step(t) { var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(target * e); if (p < 1) requestAnimationFrame(step); else el.textContent = fmt(target); })(t0);
      });
    }, { threshold: 0.6 }).observe(el);
  });
})();

/* swipe rows (home page on a phone): a row that really scrolls sideways can be reached and scrolled with the keyboard and is named for screen readers */
(function () {
  'use strict';
  var rows = [].slice.call(document.querySelectorAll('[data-swipe]'));
  var lazyRows = [].slice.call(document.querySelectorAll('.ix-tiles'));
  if (!rows.length && !lazyRows.length) return;
  function mark() {
    rows.forEach(function (r) {
      var scrolls = r.scrollWidth > r.clientWidth + 1 && getComputedStyle(r).overflowX !== 'visible';
      if (scrolls) { r.tabIndex = 0; r.setAttribute('role', 'region'); r.setAttribute('aria-label', (r.getAttribute('data-swipe') || 'List') + ', scrolls sideways'); }
      else { r.removeAttribute('tabindex'); r.removeAttribute('role'); r.removeAttribute('aria-label'); }
    });
  }
  mark(); window.addEventListener('resize', mark);
  /* the icons inside a swipe row load before the row is swiped: native lazy loading waits until an image is inside the clipped scroller, which showed a blank square while swiping */
  function eager(r) { [].slice.call(r.querySelectorAll('img[loading="lazy"]')).forEach(function (i) { if (i.getClientRects().length) i.loading = 'eager'; }); }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { eager(e.target); io.unobserve(e.target); } }); }, { rootMargin: '600px 0px' });
    rows.concat(lazyRows).forEach(function (r) { io.observe(r); });
  } else rows.concat(lazyRows).forEach(eager);
})();

/* QA sprint (Oct 2026): QA-08 footer disclosures, QA-05 rails, QA-03 demo expand */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* QA-08: long footer groups are open on wide screens and collapsed on narrow screens.
     Native <details> keeps them keyboard and screen reader accessible either way. */
  var footMq = window.matchMedia ? window.matchMedia('(max-width: 820px)') : null;
  function footApply() {
    if (!footMq) return;
    [].slice.call(document.querySelectorAll('[data-ow-foot-disc]')).forEach(function (d) {
      if (footMq.matches) d.removeAttribute('open'); else d.setAttribute('open', '');
    });
  }
  footApply();
  if (footMq && footMq.addEventListener) footMq.addEventListener('change', footApply);

  /* QA-05: every horizontal rail gets a touch cue, previous/next buttons, edge fade,
     and keyboard scrolling with a visible focus ring (styles in ow-site.css). */
  var railSel = '.ixw-tabs,.home-jobs__rail,.ix-tiles,.rday-cos,.rday-rail,.hx__chips,.jr-tabs,.ae-filters,.uc-fg,.st-filter__row,.uc-wall__cs,.jd__chips,.uc-chips,.re-tabs,.rs-picks,.fq-chips,[data-swipe]';
  var chevL = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var chevR = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  [].slice.call(document.querySelectorAll(railSel)).forEach(function (rail) {
    if (rail.closest('.ow-aic') || rail.dataset.owRail) return;
    rail.dataset.owRail = '1';
    var bar = document.createElement('div');
    bar.className = 'ow-railbar';
    bar.hidden = true;
    var cue = document.createElement('span');
    cue.className = 'ow-rail-cue';
    cue.textContent = 'Swipe to see more';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'ow-rail-btn'; prev.setAttribute('aria-label', 'Scroll back'); prev.innerHTML = chevL;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'ow-rail-btn'; next.setAttribute('aria-label', 'Scroll forward'); next.innerHTML = chevR;
    bar.appendChild(cue); bar.appendChild(prev); bar.appendChild(next);
    rail.parentNode.insertBefore(bar, rail);
    function behavior() { return reduceMotion ? 'auto' : 'smooth'; }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: behavior() }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: behavior() }); });
    rail.addEventListener('keydown', function (e) {
      if (e.target !== rail) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); rail.scrollBy({ left: 160, behavior: behavior() }); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); rail.scrollBy({ left: -160, behavior: behavior() }); }
    });
    function update() {
      var scrolls = rail.scrollWidth > rail.clientWidth + 1 && getComputedStyle(rail).overflowX !== 'visible';
      bar.hidden = !scrolls;
      var isTablist = rail.getAttribute('role') === 'tablist' || !!rail.querySelector('[role="tab"]');
      if (scrolls && !isTablist && !rail.hasAttribute('tabindex')) {
        rail.tabIndex = 0;
        rail.setAttribute('role', 'region');
        if (!rail.getAttribute('aria-label')) rail.setAttribute('aria-label', 'Scrollable list');
      }
      var atStart = rail.scrollLeft <= 1;
      var atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      prev.disabled = atStart;
      next.disabled = atEnd;
      rail.classList.toggle('ow-rail--fade-r', scrolls && atStart && !atEnd);
      rail.classList.toggle('ow-rail--fade-l', scrolls && atEnd && !atStart);
      rail.classList.toggle('ow-rail--fade-lr', scrolls && !atStart && !atEnd);
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* QA-03: on narrow screens each embedded demo (.ow-aic, which includes the AI computer
     and the real estate workflow demos) gets a "View demo larger" button. The demo node is
     moved into a native <dialog> at a larger scale and moved back on close, so its own
     controls keep working. The button is only visible under 820px (ow-site.css). */
  var dlg = null, dlgHome = null, dlgBtn = null, dlgDemo = null;
  function ensureDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'ow-demo-dialog';
    dlg.setAttribute('aria-label', 'Demo, larger view');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ow-demo-close';
    close.textContent = 'Close larger view';
    close.addEventListener('click', function () { dlg.close(); });
    dlg.appendChild(close);
    dlg.addEventListener('close', function () {
      if (dlgDemo && dlgHome && dlgHome.parentNode) dlgHome.parentNode.insertBefore(dlgDemo, dlgHome);
      if (dlgHome) dlgHome.remove();
      dlgDemo = null; dlgHome = null;
      if (dlgBtn) dlgBtn.focus();
    });
    dlg.addEventListener('click', function (e) {
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
    document.body.appendChild(dlg);
    return dlg;
  }
  [].slice.call(document.querySelectorAll('.ow-aic')).forEach(function (demo) {
    if (!demo.parentNode) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ow-demo-expand';
    btn.setAttribute('data-ow-demo-expand', '');
    btn.textContent = 'View demo larger';
    btn.addEventListener('click', function () {
      var d = ensureDialog();
      dlgBtn = btn; dlgDemo = demo;
      dlgHome = document.createComment('ow-demo-home');
      demo.parentNode.insertBefore(dlgHome, demo);
      d.appendChild(demo);
      if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
      var closeBtn = d.querySelector('.ow-demo-close');
      if (closeBtn) closeBtn.focus();
    });
    demo.parentNode.insertBefore(btn, demo);
  });
})();
